import React, { useState } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  Card,
  CardBody,
  CardTitle,
  CardSubtitle,
  CardText,
  Badge,
  Col,
  Row,
  ListGroup,
  ListGroupItem,
  CardFooter,
  ModalFooter,
} from "reactstrap";

const UserDetailModal = ({ isOpen, toggle, data }) => {
  return (
    <div>
      <Modal isOpen={isOpen} toggle={toggle}>
        <ModalHeader toggle={toggle}>User Detail</ModalHeader>
        <ModalBody>
          <Card className=" right  mt-2">
            <CardBody>
              {/* <CardTitle tag='h5'>
                        <div className='fw-bold'>Name: {`${data.organizationUser?.firstName} ${data.organizationUser?.lastName}`}</div>
                    </CardTitle> */}

              <Row className="mt-2">
                {/* Left Column */}
                <Col md="6">
                  <CardText>
                    <strong className="fs-16">Fullname:</strong>{" "}
                    {data.orguser?.firstName}{" "}
                    {data.orguser?.lastName}
                  </CardText>
                  <CardText>
                    <strong className="fs-16">Username:</strong>{" "}
                    {data?.orguser?.username}
                  </CardText>

                  <CardText>
                    <strong className="fs-16">Email:</strong>{" "}
                    {data?.orguser?.email}
                  </CardText>

                  <CardText>
                    <strong className="fs-16">Phone:</strong>{" "}
                    {data?.orguser?.phoneNumber}
                  </CardText>
                </Col>

                {/* Right Column */}
                <Col md="6">
                  <CardText>
                    <strong className="fs-16">Address:</strong>{" "}
                    {data?.orguser?.address}
                  </CardText>

                  <CardText>
                    <strong className="fs-16">ID:</strong>
                    {data.organizationUser?.id}
                  </CardText>

                  <CardText>
                    <strong className="fs-16">Modified:</strong>
                    <Badge
                      color={
                        data.organizationUser?.modifiedDate == null
                          ? "success"
                          : "danger"
                      }
                      className="ms-2"
                    >
                      {data.organizationUser?.modifiedDate == null
                        ? "not modified"
                        : "modified"}
                    </Badge>
                  </CardText>
                </Col>
              </Row>

              {/* Additional Details */}

              <Row className="mt-4 p-2">
                <Col md="6  ">
                  <CardText>
                    <strong className="fs-16">Organization ID:</strong>
                    <div>{data.organizationUser?.organizationId}</div>
                  </CardText>

                  <CardText>
                    <strong className="fs-16">Created Date:</strong>
                    <div>
                      {new Date(
                        data.organizationUser?.createdDate
                      ).toLocaleDateString()}
                    </div>
                  </CardText>
                </Col>

                <Col md="6">
                  <CardText>
                    <strong className="fs-16">Created By:</strong>
                    <div>{data.organizationUser?.createdBy}</div>
                  </CardText>
                </Col>
              </Row>

              <Row className=" mt-4 p-2 ">
                <Col md="12">
                  <CardText>
                    <strong className="fs-16">Roles:</strong>
                    <div>
                      {data.user?.roles.map((item, index) => (
                        <Badge color="secondary" key={index} className="ms-2">
                          {item}
                        </Badge>
                      ))}
                    </div>
                  </CardText>
                </Col>
              </Row>
            </CardBody>
          </Card>
        </ModalBody>
      </Modal>
    </div>
  );
};

export default UserDetailModal;
